/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown>, total: NonNullable<unknown> }} Doc_Upload_Max_Files_ExceededInputs */

const en_doc_upload_max_files_exceeded = /** @type {(inputs: Doc_Upload_Max_Files_ExceededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Limit of ${i?.max} files per upload. Only the first ${i?.max} of the ${i?.total} selected files were added; send the rest in another upload.`)
};

const pt_br2_doc_upload_max_files_exceeded = /** @type {(inputs: Doc_Upload_Max_Files_ExceededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Limite de ${i?.max} arquivos por envio. Apenas os ${i?.max} primeiros dos ${i?.total} arquivos selecionados foram adicionados; envie os demais em um novo upload.`)
};

/**
* | output |
* | --- |
* | "Limit of {max} files per upload. Only the first {max} of the {total} selected files were added; send the rest in another upload." |
*
* @param {Doc_Upload_Max_Files_ExceededInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_upload_max_files_exceeded = /** @type {((inputs: Doc_Upload_Max_Files_ExceededInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Upload_Max_Files_ExceededInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_upload_max_files_exceeded(inputs)
	return pt_br2_doc_upload_max_files_exceeded(inputs)
});